import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { INPUT_BASE_CLASSES, cx } from './formStyles';

type TextInputProps = {
  id: string;
  type?: 'text' | 'email';
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  className?: string;
};

export function TextInput({
  id,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  className
}: TextInputProps) {
  return (
    <div className="flex flex-col gap-[8px]">
      <div className="relative">
        <input
          id={id}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={cx(
            INPUT_BASE_CLASSES,
            "font-['Helvetica Neue','Arial',sans-serif]",
            'placeholder:text-[#707C8B]',
            error && 'border-red-600 pr-12',
            className
          )}
        />
        {error && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
            <ExclamationCircleIcon className="h-5 w-5 text-red-600" aria-hidden="true" />
          </div>
        )}
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
